import { render, staticRenderFns } from "./b.vue?vue&type=template&id=135fc75e&"
import script from "./b.vue?vue&type=script&lang=js&"
export * from "./b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports